<template>
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span class="crumb" @click="$router.push({ path: '/' })">首页</span>
        <span>></span>
        <span>使用帮助</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="top-nav">使用帮助</div>
          <div class="info">
            <ul>
              <li v-for="(item, i) in info" :key="i">
                <p>
                  <img
                    src="@/assets/img/icon_add.png"
                    v-if="item.isSelect == false && item.isHover == false"
                    @click="fold(item, i)"
                    @mouseover="selectStyle(i)"
                    @mouseout="outStyle(i)"
                    alt
                  />
                  <img
                    src="@/assets/img/icon_reduce.png"
                    v-if="item.isSelect == true && item.isHover == false"
                    @click="fold(item, i)"
                    @mouseover="selectStyle(i)"
                    @mouseout="outStyle(i)"
                    alt
                  />
                  <img
                    src="@/assets/img/icon_reduce1.png"
                    @mouseover="selectStyle(i)"
                    @mouseout="outStyle(i)"
                    @click="fold(item, i)"
                    v-if="item.isSelect == true && item.isHover == true"
                    alt
                  />
                  <img
                    src="@/assets/img/icon_add1.png"
                    @mouseover="selectStyle(i)"
                    @mouseout="outStyle(i)"
                    @click="fold(item, i)"
                    v-if="item.isSelect == false && item.isHover == true"
                    alt
                  />
                  <span>{{ item.title }}</span>
                </p>
                <div v-if="item.isSelect" v-html="item.content">
                  {{ item.content }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="content-r">
          <DropDownMenu></DropDownMenu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DropDownMenu from "@/components/dropDownMenu";
import { getTdkList} from "@/api/tdk";
export default {
  components: {
    DropDownMenu
  },
  data() {
    return {
      info: [
        {
          title: "怎么联系我们的客服最方便？",
          content:
            "您可以通过一下方式联系我们的客服：</br>1、发送邮件到zhoukankf@cbnweek.com</br>2、在App个人中心点击“意见反馈”并留下您的联系方式,这样书面的信息更方便我们对您的问题进行分析和追踪解决。</br>3、关注《第一财经》杂志官方微信订阅号（CBNweekly2008），在订阅号中回复您的问题</br>4、可拨打400 6060 101咨询",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        },
        {
          title: "如何订阅第一财经杂志会员？",
          content:
            "目前您可以在第一财经杂志App、官网中购买杂志会员权限。对于以后买会员权限的用户，在会有有效期内，均可在App、官网上阅读/收听付费杂志及课程&音频节目。",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        },
        {
          title: "我更换设备或者重装软件后之前的订阅信息还在吗",
          content:
            "购买第一财经杂志会员权益时会要求您先登录第一财经杂志账号。您的所有会员购买信息将与您的登录账号绑定。更换设备或重装软件后，使用您购买会员权限时使用的账号登录即可同步订单信息。",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        },
        {
          title: "iPhone用户购买杂志订阅会员权限，付款后扔不能阅读怎么办？",
          content:
            "出现此情况可能的原因可能是因为网络不稳定未能同步购买信息，请在网络良好的情况下点击个人中心页面-设置中“恢复订阅”按钮，系统将自动检查App Store中所有购买记录并账户订单核对更新。</br>如果扔有问题，您可以通过文字或电话的方式联系我们的客服人员，我们会尽全力为您解决每一个问题。",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        },
        {
          title: "手机打开App出现闪退是怎么回事？",
          content:
            "我们的产品要求手机系统版本为：安卓4.4以上、IOS9.0以上。若您无法正常使用，可以尝试升级您的手机系统。",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        },
        {
          title: "在老版本App、网站注册的账户，在新版本中为什么无法登陆？",
          content:
            "若提示密码错误，您可以点击登录页面的“忘记密码”按钮，通过验证码重置密码。</br>若提示账户不存在，您可以直接联系客服人员。",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        },
        {
          title: "在老版本购买的订单，在新版App中为何未同步或丢失？",
          content:
            "苹果用户可以先尝试点击App中个人中心页面-设置中“恢复订阅”按钮，将自动恢复您的Apple ID下之前未同步的订阅信息。若仍然无法同步，可提供账号及购买凭证，邮件至zhoukankf@cbnweek.com，我们会第一时间人工帮您同步订单。",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        },
        {
          title:
            "苹果手机就用户，在App Store中自动续订了，但又手动购买一次，怎么办？",
          content:
            "自动续订是很久之前旧版本的商品，希望您务必取消掉之前的自动续订。</br>具体操作方式为？打开iTunes软件，进入iTunes store的账户管理界面，在“设置”一栏中找到“订阅”，可以进行修改。</br>如果已经被苹果自动续订了，请联系苹果进行退款。",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        },
        {
          title: "我之前购买过杂志的电子杂志，为什么到期以后就不能看了？",
          content:
            "您购买的是某一时间段第一财经杂志所有已发布内容的阅读权。在此期间，您可以浏览杂志自创刊以来所有的杂志内容。当您的付费到期后，阅读权也将随之失效。</br>我们现共有三档付费产品供您选购，分别为28元/月，188元/年，588元/年。",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        },
        {
          title: "账号对多设备登录有限制吗？",
          content:
            "会对多设备同时登录进行一定程度的限制和提示。若您看到提示信息，请先确认进行登录操作是否为您本人，若非本人操作，可能存在账号被盗的风险，请尽快修改账户密码。同时若一个账号国语频繁的在多个设备上登录，会进行两次登录警告，之后将暂时冻结存在风险的账户。相关疑问请邮件联系客服zhoukankf@cbnweek.com。",
          isSelect: false, //是否展开
          isHover: false //鼠标是否划上
        }
      ],
      liConHeight: 50
    };
  },
  methods: {
    fold(item, index) {
      this.info[index].isSelect = !this.info[index].isSelect;
    },
    selectStyle(index) {
      this.info[index].isHover = true;
    },
    outStyle(index) {
      this.info[index].isHover = false;
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  }
};
</script>
<style lang="scss" scoped>
.content-l {
  min-height: 800px;
}
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
  span:last-child {
    color: #0091ff;
  }
}
.top-nav {
  display: flex;
  background: #ffffff;
  justify-content: space-between;
  line-height: 50px;
  align-items: center;
  padding: 0 30px;
  margin-bottom: 30px;
  font-size: 16px;
  font-weight: bold;
}
.info {
  margin-bottom: 30px;
  ul {
    li {
      background: #ffffff;
      margin-top: 30px;
      padding: 30px;
      font-size: 16px;
      p {
        position: relative;
        img {
          vertical-align: middle;
          margin-right: 4px;
          cursor: pointer;
        }
        span {
          vertical-align: middle;
        }
      }
      div {
        line-height: 30px;
        margin-top: 14px;
        margin-left: 26px;
        transition: height 0.3s;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help/index.vue